import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router-dom'

import { getOnePublic } from 'redux/api/Widgets'
import { TDashboardWidget } from 'types/GlobalWidget'

import PublicWidgetTemplate from 'components_new/templates/PublicWidgetTemplate'
import { useAutoRefresh, useDocumentTitle, useParams } from 'utils/hooks'
import { DashboardVariantType } from 'types/GlobalDashboard'

const EmbeddedWidgetPage = () => {
  const params = useParams<{ id: string }>()
  const id = params.id

  const [widget, setWidget] = useState<TDashboardWidget | null>(null)
  const [error, setError] = useState(false)
  const location = useLocation()

  useAutoRefresh()
  useDocumentTitle(widget?.title)

  useEffect(() => {
    getOnePublic(id, null, location.search)
      .then((response) => setWidget(response.data.data))
      .catch(() => setError(true))
  }, [])

  return (
    <PublicWidgetTemplate
      error={error}
      widget={widget}
      variantType={DashboardVariantType.PUBLIC}
    />
  )
}

export default EmbeddedWidgetPage
